export default __webpack_public_path__ + "static/media/background.fcba0a5c.jpg";